var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailencryption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 162,
    viewBox: "0 0 375 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 374.642,
    height: 160.561,
    transform: "translate(0.0458374 0.769775)",
    fill: "url(#pattern0_6_2291)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_2291)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M137.166 47.003L159.438 40.0752L142.305 51.9555L137.166 47.003Z",
    fill: "url(#paint0_linear_6_2291)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M159.437 40.0754L135.454 44.0355L130.311 39.083L159.437 40.0754Z",
    fill: "url(#paint1_linear_6_2291)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M135.454 44.0353V49.9754L137.165 47.003L159.437 40.0752L135.454 44.0353Z",
    fill: "url(#paint2_linear_6_2291)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M135.454 49.9756L138.877 48.6556L137.165 47.0032L135.454 49.9756Z",
    fill: "url(#paint3_linear_6_2291)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M137.166 47.0032L138.877 48.6556L138.33 48.8662L137.166 47.0032Z",
    fill: "url(#paint4_linear_6_2291)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.883 48.1826C132.481 48.3745 132.065 48.5899 131.64 48.8286",
    stroke: "#E1E1E1",
    strokeWidth: 1.21637,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.703 50.0457C125.715 52.8261 121.609 57.4884 120.646 64.1681C119.641 71.1615 121.834 79.0442 128.53 83.3039",
    stroke: "#E1E1E1",
    strokeWidth: 1.21637,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.516 83.8843C129.919 84.1043 130.339 84.3149 130.774 84.5115",
    stroke: "#E1E1E1",
    strokeWidth: 1.21637,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M228.973 75.8614L246.812 64.4258L254.673 66.9488L228.973 75.8614Z",
    fill: "url(#paint5_linear_6_2291)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M228.973 75.8613L244.39 62.9887L240.967 59.0286L228.973 75.8613Z",
    fill: "url(#paint6_linear_6_2291)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M244.39 62.9885V65.975L228.973 75.8612L244.39 62.9885Z",
    fill: "#FAD930"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M204.13 37.6037C215.09 31.2703 229.399 30.6852 241.037 37.2807C252.521 43.7872 253.919 55.9062 246.957 62.3566",
    stroke: "#E1E1E1",
    strokeWidth: 1.21637,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.712 103.769V60.7558C157.712 60.0583 158.044 59.0238 158.451 58.4621L185.188 21.1923C186.184 19.8021 187.923 19.1514 189.588 19.5493L214.731 25.5315C215.409 25.6907 216.456 26.1073 217.059 26.4584L218.294 27.1699C218.897 27.5163 219.388 28.3729 219.388 29.0704V72.0837C219.388 72.7812 218.897 73.6331 218.294 73.9842L162.234 106.386C161.63 106.732 160.644 106.732 160.041 106.386L158.806 105.674C158.203 105.328 157.712 104.471 157.712 103.774V103.769Z",
    fill: "url(#paint7_linear_6_2291)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6_2291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.712 103.769V60.7558C157.712 60.0583 158.044 59.0238 158.451 58.4621L185.188 21.1923C186.184 19.8021 187.923 19.1514 189.588 19.5493L214.731 25.5315C215.409 25.6907 216.456 26.1073 217.059 26.4584L218.294 27.1699C218.897 27.5163 219.388 28.3729 219.388 29.0704V72.0837C219.388 72.7812 218.897 73.6331 218.294 73.9842L162.234 106.386C161.63 106.732 160.644 106.732 160.041 106.386L158.806 105.674C158.203 105.328 157.712 104.471 157.712 103.774V103.769Z",
    fill: "url(#paint8_linear_6_2291)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M162.851 39.9584V94.8567C162.851 95.5542 163.342 95.8397 163.945 95.4887L216.578 65.0671C217.181 64.716 217.672 63.8687 217.672 63.1666V8.27295C217.672 7.57549 217.181 7.28995 216.578 7.64102L163.945 38.0626C163.342 38.4137 162.851 39.2609 162.851 39.9631V39.9584Z",
    fill: "url(#paint9_linear_6_2291)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.714 61.7996L157.918 59.6042C157.791 60.0068 157.717 60.4187 157.717 60.7511V103.764C157.717 104.462 158.212 105.319 158.811 105.665L160.045 106.376C160.648 106.723 161.635 106.723 162.238 106.376L162.762 106.072L161.714 61.7949V61.7996Z",
    fill: "url(#paint10_linear_6_2291)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.393 29.0704V72.0838C219.393 72.4443 219.262 72.8421 219.052 73.1932C218.879 73.4787 218.659 73.7362 218.411 73.9094L218.369 73.9328C218.346 73.9515 218.322 73.9656 218.299 73.9796L162.244 106.377H162.234C161.944 106.545 161.682 106.568 161.486 106.465C161.276 106.353 161.145 106.105 161.145 105.745V62.7313C161.145 62.0338 161.692 61.5938 162.374 61.7623L185.946 67.3748L189.032 68.1097C189.715 68.2688 190.599 67.9412 191.001 67.3701L194.578 62.3849L218.654 28.8317C219.061 28.2653 219.393 28.373 219.393 29.0704Z",
    fill: "url(#paint11_linear_6_2291)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.393 29.0704V72.0838C219.393 72.4443 219.262 72.8421 219.052 73.1932C218.879 73.4787 218.659 73.7362 218.411 73.9094L218.369 73.9328C218.346 73.9515 218.322 73.9656 218.299 73.9796L162.244 106.377H162.234C161.944 106.545 161.682 106.568 161.486 106.465C161.276 106.353 161.145 106.105 161.145 105.745V62.7313C161.145 62.0338 161.692 61.5938 162.374 61.7623L185.946 67.3748L189.032 68.1097C189.715 68.2688 190.599 67.9412 191.001 67.3701L194.578 62.3849L218.654 28.8317C219.061 28.2653 219.393 28.373 219.393 29.0704Z",
    fill: "#F1F2F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M218.293 73.9842C218.317 73.9702 218.34 73.9561 218.363 73.9374L218.406 73.914C218.653 73.7408 218.873 73.4833 219.046 73.1978C219.252 72.8514 219.383 72.4582 219.388 72.1071L194.577 62.3848L211.191 78.0894L218.293 73.9842Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M161.14 105.749C161.14 106.114 161.27 106.363 161.481 106.47C161.673 106.573 161.934 106.55 162.229 106.386H162.238L181.536 95.2265L185.945 67.3701L161.14 105.033V105.749Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.052 73.1978C218.879 73.4834 218.659 73.7408 218.411 73.914L218.369 73.9374L162.239 106.381H162.23C161.94 106.55 161.678 106.573 161.481 106.47L188.326 63.5691C189.439 61.7903 191.688 61.1022 193.605 61.9495L219.052 73.1931V73.1978Z",
    fill: "url(#paint12_linear_6_2291)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.052 73.1978C218.879 73.4834 218.659 73.7408 218.411 73.914L218.369 73.9374L162.239 106.381H162.23C161.94 106.55 161.678 106.573 161.481 106.47L188.326 63.5691C189.439 61.7903 191.688 61.1022 193.605 61.9495L219.052 73.1931V73.1978Z",
    fill: "#F1F2F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.024 52.6062C184.865 52.7045 183.962 52.3909 183.322 51.6747C182.681 50.9585 182.358 49.8585 182.358 48.3746C182.358 46.6801 182.7 45.0652 183.387 43.5299C184.074 41.9898 185.038 40.5762 186.286 39.2889C187.535 38.0016 189.003 36.8688 190.691 35.8905C192.271 34.9777 193.623 34.4722 194.745 34.3739C195.867 34.2756 196.718 34.5658 197.298 35.2399C197.878 35.9186 198.168 36.9484 198.168 38.334C198.168 39.8038 197.855 41.1192 197.223 42.28C196.592 43.4409 195.76 44.3209 194.726 44.9201C194.221 45.2103 193.805 45.3227 193.478 45.2524C193.15 45.1822 192.931 44.9669 192.819 44.6112C192.472 45.2665 192.033 45.8703 191.495 46.4227C190.957 46.975 190.354 47.4431 189.69 47.827C188.545 48.4776 187.628 48.6836 186.95 48.4449C186.272 48.2061 185.931 47.518 185.931 46.3852C185.931 44.9763 186.352 43.6422 187.189 42.3783C188.026 41.1145 189.176 40.0613 190.63 39.2187C191.261 38.8536 191.879 38.6055 192.482 38.4744C193.085 38.3433 193.581 38.3387 193.964 38.4604V42.9073C193.964 43.2677 194.025 43.4877 194.151 43.5673C194.273 43.6516 194.478 43.6094 194.764 43.4456C195.245 43.1694 195.619 42.6732 195.881 41.9664C196.148 41.2596 196.279 40.403 196.279 39.4012C196.279 38.2919 196.04 37.482 195.559 36.9812C195.077 36.4803 194.413 36.279 193.567 36.3727C192.72 36.4663 191.757 36.8267 190.668 37.454C188.68 38.6008 187.114 40.0098 185.964 41.6809C184.818 43.352 184.243 45.2197 184.243 47.2793C184.243 48.4917 184.491 49.3764 184.991 49.9334C185.491 50.4904 186.174 50.7292 187.048 50.6449C187.918 50.5607 188.909 50.2002 190.018 49.5589C190.621 49.2079 191.205 48.8006 191.766 48.3232C192.328 47.8504 192.786 47.3823 193.146 46.9142C193.207 46.844 193.258 46.7925 193.295 46.7738C193.333 46.755 193.37 46.7691 193.408 46.8206L193.871 47.6631C193.894 47.724 193.908 47.7568 193.908 47.7708C193.908 47.8317 193.866 47.9112 193.777 48.0142C193.319 48.5759 192.762 49.133 192.103 49.6853C191.444 50.2377 190.756 50.7245 190.041 51.1364C188.521 52.0118 187.184 52.4986 186.024 52.5969V52.6062ZM191.523 44.6626C191.967 44.0775 192.192 43.5158 192.192 42.9728V40.3983C191.734 40.403 191.173 40.5996 190.509 40.9834C189.667 41.4702 189.003 42.0881 188.507 42.8417C188.012 43.5954 187.768 44.3958 187.768 45.2337C187.768 45.9499 187.946 46.3759 188.306 46.5069C188.666 46.638 189.218 46.4882 189.971 46.0529C190.565 45.7112 191.079 45.2478 191.528 44.6626H191.523Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6_2291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.714 61.7996L157.918 59.6042C157.791 60.0068 157.717 60.4187 157.717 60.7511V103.764C157.717 104.462 158.212 105.319 158.811 105.665L160.045 106.376C160.648 106.723 161.635 106.723 162.238 106.376L162.762 106.072L161.714 61.7949V61.7996Z",
    fill: "#F1F2F9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.532 86.7863C167.681 87.2778 166.834 88.2515 166.348 89.5013L153.068 123.831C152.101 126.326 153.321 128.044 155.266 126.921L181.98 111.483C183.92 110.36 185.127 107.242 184.154 105.866L170.725 86.9736C170.239 86.2855 169.383 86.2948 168.537 86.7863H168.532Z",
    fill: "#D52D46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.147 122.708L164.427 88.3779C164.908 87.1281 165.759 86.1545 166.61 85.663C167.26 85.2885 167.91 85.1949 168.401 85.4804L170.328 86.5992C169.841 86.3136 169.187 86.4073 168.537 86.7817C167.686 87.2732 166.839 88.2469 166.353 89.4967L153.073 123.827C152.465 125.395 152.723 126.659 153.48 127.099L151.554 125.98C150.796 125.54 150.539 124.276 151.147 122.708Z",
    fill: "#C12B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.576 112.218L171.566 108.82L168.228 110.753L168.237 114.151L171.576 112.218Z",
    fill: "#EDEBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.66 98.269L168.083 100.338L168.088 103.498L168.799 109.452L171.015 108.169L171.67 101.429L171.66 98.269Z",
    fill: "#EDEBEC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_6_2291",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6_2291",
    transform: "scale(0.000684932 0.00158983)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6_2291",
    x: 141.494,
    y: 6.45922,
    width: 94.1125,
    height: 119.648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.24365
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.10914
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_2291"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_2291",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6_2291",
    x: 141.498,
    y: 46.6296,
    width: 37.4819,
    height: 79.4685,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.24365
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.10914
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_2291"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_2291",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_2291",
    x1: 137.166,
    y1: 46.0153,
    x2: 159.438,
    y2: 46.0153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_2291",
    x1: 130.311,
    y1: 41.5592,
    x2: 120.529,
    y2: 41.5592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_2291",
    x1: 135.454,
    y1: 45.023,
    x2: 120.528,
    y2: 45.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_2291",
    x1: 135.454,
    y1: 48.4917,
    x2: 138.877,
    y2: 48.4917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_2291",
    x1: 120.061,
    y1: 47.9347,
    x2: 138.877,
    y2: 47.9347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_2291",
    x1: 228.973,
    y1: 70.1412,
    x2: 254.673,
    y2: 70.1412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6_2291",
    x1: 228.973,
    y1: 67.4449,
    x2: 244.39,
    y2: 67.4449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6_2291",
    x1: 157.712,
    y1: 63.0354,
    x2: 219.388,
    y2: 63.0354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6_2291",
    x1: 188.55,
    y1: 19.4338,
    x2: 188.55,
    y2: 106.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6_2291",
    x1: 184.183,
    y1: 69.014,
    x2: 205.2,
    y2: 33.2082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6_2291",
    x1: 157.712,
    y1: 83.1261,
    x2: 162.762,
    y2: 83.1261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6_2291",
    x1: 161.14,
    y1: 67.5012,
    x2: 219.393,
    y2: 67.5012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6_2291",
    x1: 161.481,
    y1: 84.0623,
    x2: 219.052,
    y2: 84.0623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD930"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_2291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134.612,
    height: 120.015,
    fill: "white",
    transform: "translate(120.061 7.25708)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6_2291",
    width: 1460,
    height: 629,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailencryption);
export default __webpack_public_path__ + "static/media/emailencryption.f302204558bc1f4de0ea94c4c2253e04.svg";
export { ForwardRef as ReactComponent };